//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import portal from '@/net/portal';

export default {
  methods: {
    async clearNavCache() {
      const strCookie = document.cookie;
      const cookies = strCookie.split(' ');
      let touristId = '';
      cookies.map((str) => {
        if (str.includes('NW_TOURIST_ID')) {
          const tempArr = str.split('=');
          touristId = tempArr[1];
          if (touristId.indexOf(';') > 0) {
            touristId = touristId.substring(0, touristId.length - 1);
          }
          localStorage.setItem('TOURIST_ID', touristId);
        }
      });

      const { data } = await portal.deleteLaSaCookie({
        body: {
          activityId: '202410602943614795',
          touristId,
        },
      });
      localStorage.setItem('navigationType', '');
      this.$router.push('/');
    },
  },
};
